import { Button, Grid, Paper, Typography } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import TextFieldWrapper from "../../../components/TextField";
import {
  initialValues,
  validationSchema,
} from "../../../validation/AddGroupValidation";
import { useHistory } from "react-router";
const NewGroup = () => {
  const history = useHistory();
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(values, props) => {
        props.resetForm();
      }}
    >
      {(formik) => {
        return (
          <Form>
            <Paper style={{ width: "100%" }}>
              <Grid
                item
                container
                xs={12}
                spacing={2}
                style={{ margin: "auto" }}
              >
                <Grid item xs={12}>
                  <Typography variant="body1">گروه کاربران</Typography>
                </Grid>
                <Grid item container xs={12} justifyContent="center">
                  <Grid
                    item
                    xs={5}
                    container
                    spacing={3}
                    style={{ margin: "auto" }}
                  >
                    <Grid item xs={12}>
                      <TextFieldWrapper
                        name="newGroup"
                        label="نام گروه کاربری"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={2}
                      style={{ margin: "auto" }}
                    >
                      <Grid item xs={6}>
                        <Button
                          disabled={!formik.isValid}
                          fullWidth
                          variant="contained"
                          color="primary"
                          type="submit"
                        >
                          ذخیره
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button
                          fullWidth
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          انصراف
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Form>
        );
      }}
    </Formik>
  );
};

export default NewGroup;
